import { useContext } from 'react';
import { TD, TableRow } from '@/components/DesignLibrary/Table';
import { getDateTimeFormat } from '@/helpers/helper';
import * as ApiModels from '@/typings/api-models';
import TeamsContext from '@/providers/Teams/TeamsContext';
import { useOpenFormRequestPane } from '@/panes/formRequestHooks';
import TypeColumn from './TypeColumn';
import ActionColumn from './ActionColumn';
import TakenByColumn from './TakenByColumn';
import ItemColumn from './ItemColumn';
import { columns } from './constants';
import s from './UserWorkflowActivityThread.module.scss';

type Item = {
  action: {
    action: ApiModels.ACTIVITY_ACTIONS;
    activityType: ApiModels.ACTIVITY_TYPES_AND_ACTIONS_ROLLUP;
    type: ApiModels.ACTIVITY_TYPES | null;
  };
  details: unknown;
  id: string;
  time: string;
  user: {
    name: string | null;
    id: string | null;
  };
};

const ItemRow: React.FC<{ item: Item }> = ({ item }) => {
  const { currentTeamOwner } = useContext(TeamsContext);
  const openFormRequestPane = useOpenFormRequestPane();
  const handleClick = (): void => {
    if (
      item.details
      && typeof item.details === 'object'
      && 'formRequestId' in item.details
      && item.details.formRequestId
      && typeof item.details.formRequestId === 'string'
    ) {
      openFormRequestPane({ formRequestId: item.details.formRequestId });
    }
  };

  return (
    <TableRow key={item.id} state={item.action.type === ApiModels.ACTIVITY_TYPES.CASE_NOTE ? 'note' : undefined}>
      {columns.map(c => {
        switch (c) {
        case 'type':
          return (
            <TD key={c} compact>
              <TypeColumn item={item.action} />
            </TD>
          );
        case 'action':
          return (
            <TD key={c}>
              <ActionColumn item={item.action} details={item.details} />
            </TD>
          );
        case 'taken by':
          return (
            <TD key={c}>
              <TakenByColumn currentTeamOwner={currentTeamOwner} person={item.user} />
            </TD>
          );
        case 'item':
          return (
            <TD key={c}>
              <ItemColumn
                item={item.action}
                details={item.details}
                onClick={handleClick}
              />
            </TD>
          );
        case 'date':
          return <TD key={c} label={getDateTimeFormat(item.time)} className={s.dateCell} compact />;
        default:
          return <TD key={c} label="—" compact />;
        }
      })}
    </TableRow>
  );
};

export default ItemRow;
